import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Recurso } from "../models/recurso";

@Injectable({ providedIn: 'root' })
export class RecursoService {

    constructor(private readonly http: HttpClient) { }

    buscaRecursos(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/recurso/0/1000`)
        .pipe(
            tap(response => {
            return response
        } ))
    }

    buscaRecursoPorId(id: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/recurso/${id}`)
        .pipe(
            tap(response => {
            return response
        } ))
    }

    salvaRecurso(recurso: Recurso): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/recurso`, recurso)
        .pipe(
            tap(response => {
                return response
            })
        )
    }

    removeRecurso(idRecurso: string): Observable<any> {
        return this.http.delete<any>(`${environment.apiUrl}/recurso/${idRecurso}`)
        .pipe(
            tap(response => {
                return response
            })
        )
    }

}